import qs from 'qs'
import _ from 'lodash'

function getValueOrUndefined(params, key) {
  return _.get(params, key, undefined)
}
function getNumberOrUndefined(params, key) {
  let value = getValueOrUndefined(params, key)
  return value ? _.toInteger(value) : undefined
}

export class AppParams {
  constructor(query) {
    const params = qs.parse(query, { ignoreQueryPrefix: true })
    this.tenant = getValueOrUndefined(params, 'dl_tenant_hint')
    this.idp = getValueOrUndefined(params, 'dl_idp_hint')
    this.env = getValueOrUndefined(params, 'dl_env')
    this.sessionTimeoutSeconds = getNumberOrUndefined(params, 'dl_session_time')
    this.sessionTimeoutWarningSeconds = getNumberOrUndefined(params, 'dl_session_warn_time')
  }
}
